import { normalizeWord, textTokens } from "./script";
import type { ScriptWord } from "../types";

/** Linear phrase search; indexes always refer to the shared prompt canvas. */
export function findScriptMatches(
  words: ScriptWord[],
  query: string,
): number[] {
  const phrase = textTokens(query)
    .map((token) => normalizeWord(token.text))
    .filter(Boolean);
  if (!phrase.length) return [];
  const prefix = new Uint32Array(phrase.length);
  for (let i = 1, j = 0; i < phrase.length; i++) {
    while (j && phrase[i] !== phrase[j]) j = prefix[j - 1];
    if (phrase[i] === phrase[j]) j++;
    prefix[i] = j;
  }
  const spoken = words.filter((word) => !word.cue && word.normalized);
  const matches: number[] = [];
  for (let i = 0, j = 0; i < spoken.length; i++) {
    while (j && spoken[i].normalized !== phrase[j]) j = prefix[j - 1];
    if (spoken[i].normalized === phrase[j]) j++;
    if (j === phrase.length) {
      matches.push(spoken[i - j + 1].index);
      j = prefix[j - 1];
    }
  }
  return matches;
}

export function adjacentCue(
  markers: { wordIndex: number }[],
  position: number,
  direction: -1 | 1,
): number | undefined {
  const indexes = markers.map((marker) => marker.wordIndex);
  if (direction === 1) return indexes.find((index) => index > position);
  for (let i = indexes.length - 1; i >= 0; i--)
    if (indexes[i] < position) return indexes[i];
  return undefined;
}
